import { create } from "zustand";

type ActionOverlayState = {
  visible: boolean;
  label?: string;
  start: (label?: string) => void;
  end: () => void;
  reset: () => void;
};

let showTimeout: number | null = null;
let forceTimeout: number | null = null;
let inFlight = 0;

const SHOW_DELAY_MS = 500;
const FORCE_CLEAR_MS = 15000;

export const useActionOverlayStore = create<ActionOverlayState>((set) => ({
  visible: false,
  label: undefined,
  start: (label) => {
    inFlight += 1;
    set({ label: label || "Working…" });
    if (inFlight !== 1) return;
    if (showTimeout) {
      window.clearTimeout(showTimeout);
      showTimeout = null;
    }
    if (forceTimeout) {
      window.clearTimeout(forceTimeout);
      forceTimeout = null;
    }
    showTimeout = window.setTimeout(() => {
      if (inFlight > 0) set({ visible: true });
    }, SHOW_DELAY_MS);
    forceTimeout = window.setTimeout(() => {
      if (inFlight > 0) {
        inFlight = 0;
        set({ visible: false, label: undefined });
      }
    }, FORCE_CLEAR_MS);
  },
  end: () => {
    if (inFlight > 0) inFlight -= 1;
    if (inFlight > 0) return;
    if (showTimeout) {
      window.clearTimeout(showTimeout);
      showTimeout = null;
    }
    if (forceTimeout) {
      window.clearTimeout(forceTimeout);
      forceTimeout = null;
    }
    set({ visible: false, label: undefined });
  },
  reset: () => {
    inFlight = 0;
    if (showTimeout) {
      window.clearTimeout(showTimeout);
      showTimeout = null;
    }
    if (forceTimeout) {
      window.clearTimeout(forceTimeout);
      forceTimeout = null;
    }
    set({ visible: false, label: undefined });
  },
}));
